import React from 'react';
import { createMergingContextProvider } from './helpers';
export var overlayContextDefaults = {
    showOverlay: true,
    showFaveControl: true,
    showCommentControl: true,
    showAuthor: true,
    showPremiumFolderOverlay: true,
    showPremiumFolderIcon: true,
    showSubscriberOverlay: true,
    showSubscriberIcon: true,
    showSuggestedReasonLabel: true,
    showDailyDeviationLabel: true,
    showTitle: true,
    showStats: true,
    showAuthorName: true,
    showExtraActions: true,
    showThumbStatusIndicators: true,
    showMediaIndicators: true,
    showAuthorWatchButton: true,
};
export var OverlayContext = React.createContext(overlayContextDefaults);
OverlayContext.displayName = 'OverlayContext';
export var OverlayContextProvider = createMergingContextProvider(OverlayContext);
//# sourceMappingURL=OverlayContext.js.map